import React from 'react';
import styles from './FinanceCalculatorCalList.module.scss';

const CarList = ({ data, selectCar }) => {
  return (
    <div className={styles.grid} data-aos="fade-up" data-aos-delay="700">
      {data.map((car) => {
        // 从 Sitecore 数据中提取图片 URL
        const getImageUrl = (imageField) => {
          if (!imageField?.fields) return '';

          return (
            imageField.fields.desktopImage?.value?.src ||
            imageField.fields.tabletImage?.value?.src ||
            imageField.fields.mobileImage?.value?.src ||
            ''
          );
        };

        const imageUrl = getImageUrl(car.fields?.image);
        const title = car.fields?.title?.value || '';
        const description = car.fields?.description?.value || '';

        return (
          <div className={styles.card} key={car.id}>
            <div className={styles.imageContainer}>
              {imageUrl && <img src={imageUrl} alt={title} />}
            </div>

            <h3 className={styles.cardTitle}>{title}</h3>
            <div
              className={styles.cardDescription}
              dangerouslySetInnerHTML={{ __html: description }}
            />

            <div className={styles.buttons}>
              <button
                className={styles.viewMore}
                onClick={() => {
                  const leftButtonUrl =
                    car.fields?.leftButtonUrl?.value?.href || '/car-configurator';
                  const querystring = car.fields?.leftButtonUrl?.value?.querystring || '';
                  window.location.href = `${leftButtonUrl}${querystring}`;
                }}
              >
                {car.fields?.leftButtonText?.value || 'Configure'}
              </button>
              <button className={styles.calculate} onClick={() => selectCar(car)}>
                {car.fields?.rightButtonText?.value || 'Calculate finance'}
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default CarList;
